<!--
 * @Autor        : sandyWqh
 * @Date         : 2023-01-17 16:17:00
 * @Description  : 
 * @Version      : 1.0
 * @LastEditors  : sandyWqh
 * @LastEditTime : 2023-01-31 16:03:06
-->
<template>
  <div id="app">
    <Head></Head>
    <div class="banner">
      <img src="/static/cooperateChain.jpeg" :alt="$t('langs.cooperateChain')" />
    </div>
    <Tab />
    <div class="join_area">
      <div class="area_left">
        <div class="left_img">
          <img src="/static/join_us.jpg" alt="join us" />
        </div>
        <div class="left_img">
          <img src="/static/team_work.jpeg" alt="join us" />
        </div>
      </div>
      <div class="area_right">
        <div class="form_title">
          <span class="title">{{$t("langs.join_apply")}}</span>
        </div>
        <el-form
          :model="join_data"
          :rules="rules"
          ref="join_data"
          label-width="100px"
          class="online"
        >
          <div style="margin-top:3%;">
            <el-form-item
              :label="$t('langs.form_title.company_name')"
              prop="company_name"
              class="input_width"
            >
              <el-input v-model.trim()="join_data.company_name" required></el-input>
            </el-form-item>
            <el-form-item
              :label="$t('langs.form_title.contact_user')"
              prop="contact_user"
              required
              class="input_width"
            >
              <el-input v-model.trim()="join_data.contact_user"></el-input>
            </el-form-item>
            <el-form-item
              :label="$t('langs.form_title.mobile_phone')"
              prop="mobile_phone"
              required
              class="input_width"
            >
              <el-input v-model.trim()="join_data.mobile_phone"></el-input>
            </el-form-item>
            <el-form-item
              :label="$t('langs.form_title.email_address')"
              prop="email_address"
              required
              class="input_width"
            >
              <el-input v-model.trim()="join_data.email_address"></el-input>
            </el-form-item>
            <el-form-item
              :label="$t('langs.form_title.detial_desc')"
              prop="detial_desc"
              style="width:80%;"
            >
              <el-input type="textarea" v-model="join_data.detial_desc" rows="8"></el-input>
            </el-form-item>
          </div>
          <el-form-item>
            <el-button type="primary" class="btn_button" @click="submitForm">{{$t('langs.submit')}}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Head from "../components/head/head.vue";
import Footer from "../components/footer/footer.vue";
import Tab from "../components/about/tab.vue";
import axios from "axios";
export default {
  name: "enquiry",
  components: { Head, Footer, Tab },
  data() {
    return {
      join_data: {
        contact_user: "",
        mobile_phone: "",
        email_address: "",
        company_name: "",
        detial_desc: ""
      },
      rules: {
        contact_user: [
          {
            required: true,
            message: this.$t("langs.valid_message.contact_user"),
            trigger: "blur"
          }
        ],
        mobile_phone: [
          {
            pattern: /^1(3[0-9]|4[01456879]|5[0-35-9]|6[2567]|7[0-8]|8[0-9]|9[0-35-9])\d{8}$/,
            required: true,
            message: this.$t("langs.valid_message.mobile_phone"),
            trigger: "blur"
          }
        ],
        email_address: [
          {
            // pattern: /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/,
            message: this.$t("langs.valid_message.email_address"),
            trigger: "blur",
            required: true,
            type: "email"
          }
        ],
        detial_desc: [
          {
            min: 20,
            max: 2000,
            required: true,
            message: this.$t("langs.valid_message.detial_desc"),
            trigger: "blur"
          }
        ]
      }
    };
  },
  methods: {
    submitForm() {
      this.$refs["join_data"].validate(valid => {
        if (valid) {
          let data = Object.assign({}, this.join_data);
          data.record_type = 1;
          let vm = this;
          axios
            .post("/api/admin/base/open/consult", data)
            .then(res => {
              vm.$message({
                message: "提交成功",
                type: "success",
                duration: 1000
              });
              vm.resetForm();
            })
            .catch(error => {
              vm.$message({
                message: "操作异常",
                type: "error",
                duration: 1000
              });
            });
        }
      });
    },
    resetForm() {
      this.$refs["join_data"].resetFields();
    }
  }
};
</script>

<style  scoped>
@import "../assets/css/common.css";
.join_area {
  width: 100%;
  height: auto;
  display: flex;
  background-color: rgba(216, 216, 216, 0.12);
}
.area_left,
.area_right {
  flex: 1;
  padding: 20px;
  text-align: center;
}
.area_left {
  margin-top: 7%;
}
.left_img {
  width: 80%;
  height: auto;
  margin-left: 5%;
}
.left_img img {
  width: 360px;
  height: 240px;
}

.area_right {
  margin-left: -5%;
  margin-right: 5%;
  margin-top: 2%;
}
.form_title {
  font-family: "Courier New", Courier, monospace;
  padding-bottom: 2%;
}
.form_title .title {
  margin-left: -10%;
  font-size: 28px;
  font-weight: 600;
  color: #666666;
}

.input_width {
  width: 80%;
}
.select_width {
  width: 42%;
}
.btn_button {
  margin-left: -20% !important;
}
</style>


// WEBPACK FOOTER //
// src/view/cooperate_chain.vue